import { useEffect } from "react";
import { Link } from "react-router-dom";
import ParentsQuickNav from "./ParentsQuickNav";

function NurseryGearPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const products = [
    { name: "Eco-Friendly Cribs", icon: "🛏️", description: "Safe, sustainable sleep for your baby!", color: "from-emerald-100 to-green-200" },
    { name: "Ergonomic Highchairs", icon: "🪑", description: "Comfort and safety for mealtime!", color: "from-green-100 to-lime-200" },
    { name: "Cozy Gliders", icon: "🪑", description: "Rock your little one to sleep in comfort!", color: "from-teal-100 to-emerald-200" },
    { name: "Changing Tables", icon: "🧸", description: "Organized and safe diaper changes!", color: "from-lime-100 to-green-200" }
  ];

  const handleBackClick = (e: React.MouseEvent) => {
    e.preventDefault();
    localStorage.setItem('scrollTarget', 'parents');
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-emerald-50 py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Back Button */}
        <div className="mb-8">
          <a
            href="/"
            onClick={handleBackClick}
            className="inline-flex items-center gap-2 text-emerald-600 hover:text-green-600 font-bold text-lg transition-colors duration-300"
          >
            <span className="text-2xl">←</span> Back to Parent's Corner
          </a>
        </div>

        {/* Page Title */}
        <h1 className="text-4xl md:text-6xl font-black text-center mb-8" style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
          <span className="text-emerald-600">Nursery &</span>{" "}
          <span className="text-green-600">Gear</span> 🛏️
        </h1>

        {/* Quick Navigation */}
        <ParentsQuickNav />

        {/* Products Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-2xl border-6 border-emerald-300"
            >
              <div className="p-4 md:p-6">
                <div className={`aspect-square rounded-2xl bg-gradient-to-br ${product.color} mb-3 md:mb-4 flex items-center justify-center`}>
                  <span className="text-5xl md:text-7xl">{product.icon}</span>
                </div>
                <h4 className="text-base md:text-xl font-bold text-gray-800 mb-1 md:mb-2">{product.name}</h4>
                <p className="text-xs md:text-sm text-gray-600 mb-3 md:mb-4">{product.description}</p>
                <button className="w-full bg-sky-500 hover:bg-sky-600 text-white font-black text-xs md:text-sm py-2 md:py-3 px-3 md:px-6 rounded-full shadow-lg transform transition-all duration-300 hover:scale-105 active:scale-95">
                  👁️ View on Amazon
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NurseryGearPage;
